<template>
  <v-form class="my-2"
    v-model="detailMixin.valid"
    ref="formAfmeting">
    <div
    v-if="detailMixin.element && detailMixin.element.afmetingen"
    :class="DetailMixin_Dirty ? 'dirtyForm' : DetailMixin_Revertable && !detailMixin.element.isNew ? 'editForm' : ''"
    >
      <div class="d-flex align-center justify-space-between mb-3">
        <h2 class="primary--text mb-0">Afmetingen</h2>
      </div>
      <h3 class="secondary--text my-3">Perceel</h3>
      <v-row class="pb-0">
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="Perceelbreedte" suffix="m" v-model="detailMixin.element.afmetingen.perceelBreedte" />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="Perceeloppervlakte" suffix="m²" v-model="detailMixin.element.afmetingen.perceelOppervlakte" />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="Breedte voorgevel" suffix="m" v-model="detailMixin.element.afmetingen.voorgevelBreedte" />
        </v-col>
      </v-row>

      <v-divider class="my-5"></v-divider>

      <h3 class="secondary--text my-3">Bebouwde oppervlakte</h3>
      <v-row class="pb-0">
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="Kelder" suffix="m²" v-model="detailMixin.element.afmetingen.oppervlakteKelder" />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="Gelijkvloers" suffix="m²" v-model="detailMixin.element.afmetingen.oppervlakteGelijkvloers" />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="1ste Verdieping" suffix="m²" v-model="detailMixin.element.afmetingen.oppervlakteVerdieping1" />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="2de Verdieping" suffix="m²" v-model="detailMixin.element.afmetingen.oppervlakteVerdieping2" />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="3de Verdieping" suffix="m²" v-model="detailMixin.element.afmetingen.oppervlakteVerdieping3" />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="Dakverdieping" suffix="m²" v-model="detailMixin.element.afmetingen.oppervlakteVerdiepingDak" />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <control-number :decimals="2" label="Garage" suffix="m²" v-model="detailMixin.element.afmetingen.garageOppervlakte" />
        </v-col>
        <v-col cols="12" sm="12">
          <h4 class="secondary--text mb-2">Bijgebouwen</h4>
        </v-col>
        <v-col cols="12" v-if="detailMixin.element.afmetingen.bijgebouwen && detailMixin.element.afmetingen.bijgebouwen.length > 0">
          <v-row v-for="(bijgebouw, index) in detailMixin.element.afmetingen.bijgebouwen" :key="bijgebouw.idBijgebouw || index" dense>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Omschrijving"
                v-model="bijgebouw.omschrijving"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="5">
              <control-number
                :decimals="2"
                label="Oppervlakte"
                suffix="m²"
                v-model="bijgebouw.oppervlakteBijgebouw"
              />
            </v-col>
            <v-col cols="12" sm="1" class="d-flex justify-end">
              <v-btn
                class="deleteItem"
                icon
                @click="DeleteBijgebouw(bijgebouw.idBijgebouw, index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-btn
              color="primary"
              @click="CreateBijgebouw"
              >
              Voeg bijgebouw toe
            </v-btn>
          </v-col>
      </v-row>

      <v-divider class="my-5"></v-divider>

      <h3 class="secondary--text my-3">Extra afmetingen</h3>
      <v-row class="pb-0">
        <v-col cols="12" md="6">
          <v-textarea label="Beschrijving" auto-grow single-line outlined v-model="detailMixin.element.afmetingen.extra" />
        </v-col>
      </v-row>

      <v-divider class="my-5"></v-divider>

      <h3 class="secondary--text my-3">Bijlage</h3>
      <v-row class="pb-0">
        <v-col cols="12" md="6">
          <control-file-input-drag-and-drop v-model="detailMixin.element.files" @download="Download($event)" :accept="['.png', '.jpg', '.jpeg', '.gif']"/>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import ControlNumber from '../ControlNumber.vue'
import ControlFileInputDragAndDrop from '../ControlFileInputDragAndDrop.vue'
import schattingService from '../../services/schattingService'
import commonMixin from '../../mixins/commonMixin'
import errorMixin from '../../mixins/errorMixin'
import detailMixin from '../../mixins/detailMixin'
import blobMixin from '../../mixins/blobMixin'
import offlineStorage from '@/utils/offlineStorage'
import networkStatus from '@/utils/networkStatus'
import { debounce } from 'lodash'

export default {
  mixins: [
    commonMixin,
    errorMixin,
    detailMixin,
    blobMixin
  ],
  components: {
    ControlNumber,
    ControlFileInputDragAndDrop
  },
  props: {
    idSchatting: {
      default: null,
      type: String
    },
    visible: Boolean
  },
  data () {
    return {
      referentieType: 'e800b130-e7f5-453d-8cd8-fe73c7959e88'
    }
  },
  mounted () {
    schattingService.Init(this)
    this.initAutoSave()
  },
  watch: {
    async visible () {
      if (this.visible) {
        await this.SetVariables()
        await this.GetSchatting()
      } else if (this.DetailMixin_Dirty) {
        this.DetailMixin_Save()
      }
    },
    // Deep watch for automatic caching of afmetingen data
    'detailMixin.element.afmetingen': {
      deep: true,
      handler: function (newVal, oldVal) {
        // Only auto-save if we have data and it's not the initial load
        if (newVal && oldVal && this.idSchatting) {
          this.debouncedAutoSave()
        }
      }
    }
  },
  methods: {
    initAutoSave () {
      // Create a debounced version of the auto-save function
      // This will wait 1 second after the last change before saving
      this.debouncedAutoSave = debounce(this.autoSaveToCache, 1000)
    },
    async autoSaveToCache () {
      const id = this.DetailMixin_GetId()
      if (!id || !this.detailMixin.element?.afmetingen) return

      try {
        await offlineStorage.saveSchattingStep('afmetingen', id, this.detailMixin.element.afmetingen)
        this.CommonMixin_Snackbar('Aanpassing lokaal opgeslagen', 'success')
      } catch (error) {
        console.error('Auto-save to cache failed:', error)
        this.CommonMixin_Snackbar('Automatisch opslaan mislukt', 'error')

        // Clear the error message after 3 seconds
        setTimeout(() => {
          if (this.autoSaveStatus === 'error') {
            this.autoSaveStatus = null
            this.autoSaveMessage = ''
          }
        }, 3000)
      }
    },
    Download (blob) {
      const blobFormatted = this.CommonMixin_Clone(blob)
      blobFormatted.bestandsnaam = blob.name
      this.BlobMixin_Download(blobFormatted)
    },
    async GetSchatting () {
      this.CommonMixin_Load(this.$options.name, true)

      const id = this.DetailMixin_GetId()

      if (id) {
        const element = {
          afmetingen: {},
          files: []
        }

        const cachedAfmetingen = await offlineStorage.getSchattingStep('afmetingen', id)

        if (cachedAfmetingen && offlineStorage.isDataValid(cachedAfmetingen)) {
          element.afmetingen = this.CommonMixin_Clone(cachedAfmetingen)
          if (!element.afmetingen.bijgebouwen) {
            element.afmetingen.bijgebouwen = []
          }
          this.detailMixin.element = this.CommonMixin_Clone(element)
          this.DetailMixin_InitDirtyWatch()
          this.$forceUpdate()
        }

        // Try to fetch blob files if online
        if (networkStatus.isOnline()) {
          try {
            const files = await this.BlobMixin_GetFiles(this.idSchatting, this.referentieType)
            this.detailMixin.element.files = files
            this.$forceUpdate()
          } catch (error) {
            console.warn('Kon blobs niet ophalen:', error)
            if (!cachedAfmetingen) {
              console.error('Geen cached data beschikbaar voor afmetingen')
            }
          }
        }
        this.DetailMixin_InitDirtyWatch()
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async CreateBijgebouw () {
      var nieuwBijgebouw = {
        idBijgebouw: null,
        idAfmeting: this.detailMixin.element.afmetingen.idAfmeting,
        omschrijving: null,
        oppervlakteBijgebouw: null
      }

      if (!this.detailMixin.element.afmetingen.bijgebouwen) {
        this.detailMixin.element.afmetingen.bijgebouwen = []
      }
      this.detailMixin.element.afmetingen.bijgebouwen.push(nieuwBijgebouw)
    },
    async DeleteBijgebouw (idBijgebouw, index) {
      if (idBijgebouw) {
        await schattingService.DeleteSchattingAfmetingBijgebouw(idBijgebouw)
      }
      this.detailMixin.element.afmetingen.bijgebouwen.splice(index, 1)
    },
    SetVariables () {
      this.detailMixin.key = 'id'
      this.detailMixin.rightsNeeded = ['admin', 'gebruiker']
      this.detailMixin.functions.validate = this.$refs.formAfmeting.validate
      this.detailMixin.functions.save = this.save
    },
    async save (element) {
      var allBijgebouwen = element.afmetingen.bijgebouwen || []
      var newBijgebouwen = allBijgebouwen.filter(b => !b.idBijgebouw)
      console.log('New bijgebouwen to add:', newBijgebouwen)
      if (newBijgebouwen.length !== 0) {
        await schattingService.CreateSchattingAfmetingBijgebouw(newBijgebouwen)
      }
      var schattingAfmeting = await schattingService.UpdateSchattingAfmeting(element.afmetingen)
      await schattingService.UpdateSchattingAfmetingBijgebouwen(element.afmetingen.bijgebouwen || [])
      await this.BlobMixin_SaveFiles(element.files, this.idSchatting, this.referentieType)
      var schattingAfmetingData = null
      if (schattingAfmeting && schattingAfmeting.data) {
        schattingAfmetingData = schattingAfmeting.data
      }
      return {
        data: {
          afmetingen: schattingAfmetingData
        }
      }
    },
    Validate () {
      this.$refs.formAfmeting.validate()
      return this.detailMixin.valid
    }
  }
}

</script>
